import * as React from 'react';
import type { SVGProps } from 'react';
const SvgOther = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width={21}
    height={20}
    fill='none'
    {...props}
  >
    <rect width={19} height={19} x={1.3} y={0.5} fill='#fff' rx={9.5} />
    <rect width={19} height={19} x={1.3} y={0.5} fill='url(#other_svg__a)' rx={9.5} />
    <defs>
      <pattern id='other_svg__a' width={1} height={1} patternContentUnits='objectBoundingBox'>
        <use xlinkHref='#other_svg__b' transform='scale(.00195)' />
      </pattern>
      <image
        xlinkHref='/images/icons/other-ab726ae1.webp'
        id='other_svg__b'
        width={512}
        height={512}
      />
    </defs>
  </svg>
);
export default SvgOther;
